import { object, string } from 'yup';

const UserValidationSchema = object({
  firstName: string('Enter First Name')
    .max(120, 'First Name cannot be more than 120 characters.')
    .min(3, 'First Name cannot be less than 3 characters.')
    .required('First Name is required.'),
  lastName: string('Enter Last Name')
    .max(120, 'Last Name cannot be more than 120 characters.')
    .min(3, 'Last Name cannot be less than 3 characters.')
    .required('Last Name is required.'),
  email: string('Enter Email').email().required(),
  password: string('Enter Password').required('Password is required'),
});

export default UserValidationSchema;
